import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/areas/admin/adminAreaQueryKeys.ts
var t = e("admin-areas", {
	list: (e) => ["list", e ?? ""],
	types: () => ["types"],
	attractions: (e, t) => t ? [
		"attractions",
		e,
		t
	] : ["attractions", e],
	placeSearch: (e, t) => [
		"place-search",
		e,
		t
	]
});
//#endregion
export { t as adminAreaQueryKeys };
